export const RUN_HISTORY_ENTRY_TEST_ID = "run-history-entry";
export const RUN_HISTORY_ENTRY_LABEL_TEST_ID = "run-history-entry-label";
export const RUN_HISTORY_ENTRY_INFO_TEST_ID = "run-history-entry-info";
export const RUN_HISTORY_ENTRY_CONTENT_TEST_ID = "run-history-entry-content";
